<!-- Shared field style: compact inputs, subtle radius -->
<!-- Tab 0 -->
<ng-container *ngIf="tabNumber === 0">
    <div class="space-y-6">
        <header class="space-y-0.5">
            <h2 class="text-base font-semibold text-slate-900">Dati ordine</h2>
            <p class="text-sm text-slate-500">Inserisci i contatti e l’indirizzo di consegna.</p>
        </header>

        <form class="space-y-8" [formGroup]="infoForm">
            <section class="space-y-3">
                <h3 class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Contatti</h3>
                <div class="grid gap-3 sm:grid-cols-2">
                    <div>
                        <label for="email" class="mb-1 block text-xs font-medium text-slate-600">
                            Email <span class="text-red-500">*</span>
                        </label>
                        <input id="email" type="email" formControlName="email" required
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                    </div>
                    <div>
                        <label for="fiscalCode" class="mb-1 block text-xs font-medium text-slate-600">
                            Codice fiscale <span class="text-red-500">*</span>
                        </label>
                        <input id="fiscalCode" type="text" formControlName="fiscalCode" required
                            minlength="16" maxlength="16" pattern="[a-zA-Z0-9]{16}"
                            (blur)="onFiscalCodeBlur()"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm uppercase text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30"
                            [class.border-red-300]="infoForm.get('fiscalCode')?.invalid && infoForm.get('fiscalCode')?.touched" />
                        <p *ngIf="infoForm.get('fiscalCode')?.invalid && infoForm.get('fiscalCode')?.touched"
                            class="mt-1 text-xs text-red-600">
                            Il codice fiscale deve essere di 16 caratteri alfanumerici.
                        </p>
                    </div>
                </div>
            </section>

            <section class="space-y-3">
                <h3 class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Indirizzo di spedizione</h3>
                <div class="grid gap-3 sm:grid-cols-2">
                    <div>
                        <label for="firstName" class="mb-1 block text-xs font-medium text-slate-600">
                            Nome <span class="text-red-500">*</span>
                        </label>
                        <input id="firstName" formControlName="firstName" required
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                    </div>
                    <div>
                        <label for="lastName" class="mb-1 block text-xs font-medium text-slate-600">
                            Cognome <span class="text-red-500">*</span>
                        </label>
                        <input id="lastName" formControlName="lastName" required
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                    </div>
                </div>

                <div>
                    <label for="address" class="mb-1 block text-xs font-medium text-slate-600">
                        Indirizzo <span class="text-red-500">*</span>
                    </label>
                    <input id="address" formControlName="address" required
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>

                <div>
                    <label for="optional" class="mb-1 block text-xs font-medium text-slate-600">
                        Interno, scala, ecc. <span class="font-normal text-slate-400">(facoltativo)</span>
                    </label>
                    <input id="optional" formControlName="optional"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>

                <div class="grid gap-3 sm:grid-cols-3">
                    <div>
                        <label for="zip" class="mb-1 block text-xs font-medium text-slate-600">
                            CAP <span class="text-red-500">*</span>
                        </label>
                        <input id="zip" formControlName="zip" required
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                    </div>
                    <div>
                        <label for="city" class="mb-1 block text-xs font-medium text-slate-600">
                            Città <span class="text-red-500">*</span>
                        </label>
                        <input id="city" formControlName="city" required
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                    </div>
                    <div>
                        <label for="province" class="mb-1 block text-xs font-medium text-slate-600">
                            Provincia <span class="text-red-500">*</span>
                        </label>
                        <input id="province" formControlName="province" required
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                    </div>
                </div>
            </section>
        </form>

        <button type="button" (click)="differentFiscalAddressChange()"
            class="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-left text-sm font-medium text-slate-800 transition hover:border-slate-300 hover:bg-slate-100/80 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25"
            [class.border-[var(--primary-color)]]="differentFiscalAddress"
            [class.bg-[color:rgba(var(--primary-rgb),0.08)]]="differentFiscalAddress"
            [class.ring-1]="differentFiscalAddress"
            [class.ring-[var(--primary-color)]]="differentFiscalAddress">
            Utilizza un indirizzo diverso per la fatturazione
        </button>

        <div *ngIf="differentFiscalAddress"
            class="space-y-4 rounded-xl border border-dashed border-slate-200 bg-slate-50/50 p-4 sm:p-5">
            <h3 class="text-sm font-semibold text-slate-900">Indirizzo di fatturazione</h3>

            <div class="grid gap-3 sm:grid-cols-2">
                <div>
                    <label for="legalFirstName" class="mb-1 block text-xs font-medium text-slate-600">
                        Nome <span class="text-red-500">*</span>
                    </label>
                    <input id="legalFirstName" [(ngModel)]="address.legalFirstName"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
                <div>
                    <label for="legalLastName" class="mb-1 block text-xs font-medium text-slate-600">
                        Cognome <span class="text-red-500">*</span>
                    </label>
                    <input id="legalLastName" [(ngModel)]="address.legalLastName"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
            </div>

            <div>
                <label for="legalAddress" class="mb-1 block text-xs font-medium text-slate-600">
                    Indirizzo <span class="text-red-500">*</span>
                </label>
                <input id="legalAddress" [(ngModel)]="address.legalAddress"
                    class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
            </div>

            <div class="grid gap-3 sm:grid-cols-3">
                <div>
                    <label for="legalZip" class="mb-1 block text-xs font-medium text-slate-600">
                        CAP <span class="text-red-500">*</span>
                    </label>
                    <input id="legalZip" [(ngModel)]="address.legalZip"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
                <div>
                    <label for="legalCity" class="mb-1 block text-xs font-medium text-slate-600">
                        Città <span class="text-red-500">*</span>
                    </label>
                    <input id="legalCity" [(ngModel)]="address.legalCity"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
                <div>
                    <label for="legalProvince" class="mb-1 block text-xs font-medium text-slate-600">
                        Provincia <span class="text-red-500">*</span>
                    </label>
                    <input id="legalProvince" [(ngModel)]="address.legalProvince"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
            </div>

            <div class="grid gap-3 sm:grid-cols-2">
                <div>
                    <label for="businessName" class="mb-1 block text-xs font-medium text-slate-600">Ragione sociale</label>
                    <input id="businessName" [(ngModel)]="address.businessName"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
                <div>
                    <label for="vat" class="mb-1 block text-xs font-medium text-slate-600">Partita IVA</label>
                    <input id="vat" [(ngModel)]="address.vat"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
            </div>

            <div class="grid gap-3 sm:grid-cols-2">
                <div>
                    <label for="sdi" class="mb-1 block text-xs font-medium text-slate-600">SDI</label>
                    <input id="sdi" [(ngModel)]="address.sdi"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
                <div>
                    <label for="pec" class="mb-1 block text-xs font-medium text-slate-600">PEC</label>
                    <input id="pec" [(ngModel)]="address.pec"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                </div>
            </div>

            <div>
                <label for="legalOptional" class="mb-1 block text-xs font-medium text-slate-600">
                    Interno, scala, ecc. <span class="font-normal text-slate-400">(facoltativo)</span>
                </label>
                <input id="legalOptional" [(ngModel)]="address.legalAddressOptional"
                    class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm transition focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
            </div>
        </div>

        <div class="flex justify-end border-t border-slate-100 pt-4">
            <button type="button" (click)="saveInfo()" [disabled]="infoForm.invalid"
                class="inline-flex items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                style="background-color: var(--primary-color)">
                Salva
            </button>
        </div>
    </div>
</ng-container>

<!-- Tab 1 -->
<ng-container *ngIf="tabNumber === 1">
    <div class="space-y-5">
        <header class="space-y-0.5">
            <h2 class="text-base font-semibold text-slate-900">Spedizione</h2>
            <p class="text-sm text-slate-500">Verifica i dati e scegli la consegna.</p>
        </header>

        <div class="divide-y divide-slate-100 rounded-lg border border-slate-100 bg-slate-50/40">
            <div class="px-4 py-3 sm:px-4 sm:py-3.5">
                <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Contatto</p>
                <p class="mt-1 text-sm font-medium text-slate-900">{{ infoForm.get('email')?.value }}</p>
                <p class="mt-0.5 text-sm text-slate-600">{{ infoForm.get('fiscalCode')?.value }}</p>
            </div>
            <div class="px-4 py-3 sm:px-4 sm:py-3.5">
                <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Spedisci a</p>
                <p class="mt-1 text-sm leading-relaxed text-slate-700">{{ getFullAddress() }}</p>
            </div>
        </div>

        <div>
            <h3 class="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Modalità di spedizione</h3>
            <div class="space-y-2">
                <ng-container *ngFor="let shipmetInfo of companyShipmentType">
                    <button type="button" (click)="setSelectedShipment(shipmetInfo)"
                        class="group flex w-full items-start justify-between gap-3 rounded-lg border bg-white px-3 py-3 text-left text-sm transition hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25"
                        [class.border-slate-200]="shipmetInfo.id !== selectedShipment?.id"
                        [class.border-[var(--primary-color)]]="shipmetInfo.id === selectedShipment?.id"
                        [class.ring-1]="shipmetInfo.id === selectedShipment?.id"
                        [class.ring-[var(--primary-color)]]="shipmetInfo.id === selectedShipment?.id"
                        [class.bg-[color:rgba(var(--primary-rgb),0.06)]]="shipmetInfo.id === selectedShipment?.id">
                        <span class="font-medium text-slate-900">{{ shipmetInfo.type }}</span>
                        <span
                            class="shrink-0 rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold tabular-nums text-slate-700 group-hover:bg-slate-200/80"
                            [class.bg-white]="shipmetInfo.id === selectedShipment?.id"
                            [class.text-[var(--primary-color)]]="shipmetInfo.id === selectedShipment?.id">
                            {{ shipmetInfo.price | currency: 'EUR' }}
                        </span>
                    </button>
                </ng-container>
            </div>
        </div>

        <div class="flex justify-end border-t border-slate-100 pt-4">
            <button type="button" (click)="saveOrder()" [disabled]="!selectedShipment"
                class="inline-flex items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                style="background-color: var(--primary-color)">
                Salva
            </button>
        </div>
    </div>
</ng-container>

<!-- Tab 2 -->
<ng-container *ngIf="tabNumber === 2">
    <div class="space-y-6">
        <header class="space-y-0.5">
            <h2 class="text-base font-semibold text-slate-900">Pagamento</h2>
            <p class="text-sm text-slate-500">Metodo e accettazione termini.</p>
        </header>

        <section class="space-y-2">
            <p class="text-xs font-semibold text-slate-700">
                Metodo di pagamento <span class="text-red-500">*</span>
            </p>
            <div class="space-y-2">
                <label *ngIf="company.wireTransferEnabled"
                    class="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5 transition hover:border-slate-300 has-[:checked]:border-[var(--primary-color)] has-[:checked]:bg-[color:rgba(var(--primary-rgb),0.06)] has-[:checked]:ring-1 has-[:checked]:ring-[var(--primary-color)]">
                    <input required
                        class="h-4 w-4 border-slate-300 text-[var(--primary-color)] focus:ring-[var(--primary-color)]"
                        type="radio" name="payment-method" id="wire-transfer-method" value="transfer"
                        [(ngModel)]="paymentMethod" />
                    <span class="text-sm font-medium text-slate-800">Bonifico bancario</span>
                </label>
                <label *ngIf="company.nexiEnabled"
                    class="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5 transition hover:border-slate-300 has-[:checked]:border-[var(--primary-color)] has-[:checked]:bg-[color:rgba(var(--primary-rgb),0.06)] has-[:checked]:ring-1 has-[:checked]:ring-[var(--primary-color)]">
                    <input required
                        class="h-4 w-4 border-slate-300 text-[var(--primary-color)] focus:ring-[var(--primary-color)]"
                        type="radio" name="payment-method" id="nexi-method" value="nexi" [(ngModel)]="paymentMethod" />
                    <span class="text-sm font-medium text-slate-800">Nexi</span>
                </label>
                <label *ngIf="company.nexiRatesEnabled"
                    class="flex cursor-pointer items-start gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5 transition hover:border-slate-300 has-[:checked]:border-[var(--primary-color)] has-[:checked]:bg-[color:rgba(var(--primary-rgb),0.06)] has-[:checked]:ring-1 has-[:checked]:ring-[var(--primary-color)]">
                    <input required
                        class="mt-0.5 h-4 w-4 shrink-0 border-slate-300 text-[var(--primary-color)] focus:ring-[var(--primary-color)]"
                        type="radio" name="payment-method" id="nexiRates-method" value="nexiRates"
                        [(ngModel)]="paymentMethod" />
                    <span class="text-sm font-medium leading-snug text-slate-800">
                        Rate mensili PagoDIL
                        <span *ngIf="company.nexiRatesCommissionPercent">
                            <span *ngIf="+company.nexiRatesCommissionPercent !== 0" class="ml-1 text-slate-500">
                                + %{{ company.nexiRatesCommissionPercent }}
                            </span>
                        </span>
                    </span>
                </label>
                <label *ngIf="company.appPagoRatesEnabled"
                    class="flex cursor-pointer items-start gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5 transition hover:border-slate-300 has-[:checked]:border-[var(--primary-color)] has-[:checked]:bg-[color:rgba(var(--primary-rgb),0.06)] has-[:checked]:ring-1 has-[:checked]:ring-[var(--primary-color)]">
                    <input required
                        class="mt-0.5 h-4 w-4 shrink-0 border-slate-300 text-[var(--primary-color)] focus:ring-[var(--primary-color)]"
                        type="radio" name="payment-method" id="appPagoRates-method" value="appPagoRates"
                        [(ngModel)]="paymentMethod" />
                    <span class="flex items-center gap-2 text-sm font-medium leading-snug text-slate-800">
                        <img src="assets/icons/appPago.svg" alt="" class="h-4 w-auto">
                        Rate AppPago
                        <span *ngIf="company.appPagoCommissionPercent">
                            <span *ngIf="+company.appPagoCommissionPercent !== 0" class="ml-1 text-slate-500">
                                + %{{ company.appPagoCommissionPercent }}
                            </span>
                        </span>
                    </span>
                </label>
            </div>
            <p *ngIf="!company.wireTransferEnabled && !company.nexiEnabled && !company.nexiRatesEnabled && !company.appPagoRatesEnabled"
                class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
                Ancora nessun metodo di pagamento impostato dalla società.
            </p>
        </section>

        <section class="space-y-2">
            <p class="text-xs font-semibold text-slate-700">
                Privacy policy <span class="text-red-500">*</span>
            </p>
            <label
                class="flex cursor-pointer items-start gap-3 rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2.5 transition hover:bg-slate-50 has-[:checked]:border-[var(--primary-color)]">
                <input name="terms" required
                    class="mt-0.5 h-4 w-4 rounded border-slate-300 text-[var(--primary-color)] focus:ring-[var(--primary-color)]"
                    type="checkbox" id="terms-and-conditions" [(ngModel)]="termsAndConditions" />
                <span class="text-sm text-slate-700">Accetto termini e condizioni imposti dal servizio</span>
            </label>
        </section>

        <div class="flex justify-end border-t border-slate-100 pt-4">
            <button type="button" (click)="createOrder()" [disabled]="!(termsAndConditions && paymentMethod)"
                class="inline-flex items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                style="background-color: var(--primary-color)">
                Salva
            </button>
        </div>
    </div>

    <form #nexiForm ngNoForm method="POST" action="{{ getNexiUrl() }}" class="hidden">
        <input type="hidden" name="alias" [value]="nexiAlias" />
        <input type="hidden" name="importo" [value]="importo" />
        <input type="hidden" name="divisa" [value]="divisa" />
        <input type="hidden" name="codTrans" [value]="codTrans" />
        <input type="hidden" name="url" [value]="url" />
        <input type="hidden" name="url_back" [value]="url_back" />
        <input type="hidden" name="mac" [value]="nexiMac" />
        <input type="hidden" name="email" [value]="email" />
        <input type="hidden" name="3dsDinamico" [value]="value3dsDinamico" />
        <input type="hidden" name="urlpost" [value]="urlpost" />
    </form>

    <form #nexiRatesForm ngNoForm method="POST" action="{{ getNexiUrl() }}" class="hidden">
        <input type="hidden" name="alias" [value]="nexiRatesAlias" />
        <input type="hidden" name="importo" [value]="importo" />
        <input type="hidden" name="divisa" [value]="divisa" />
        <input type="hidden" name="codTrans" [value]="codTrans" />
        <input type="hidden" name="url" [value]="url" />
        <input type="hidden" name="url_back" [value]="url_back" />
        <input type="hidden" name="mac" [value]="nexiRatesMac" />
        <input type="hidden" name="email" [value]="email" />
        <input type="hidden" name="3dsDinamico" [value]="value3dsDinamico" />
        <input type="hidden" name="urlpost" [value]="urlpost" />
        <input type="hidden" name="nome" [value]="this.infoForm.get('firstName')?.value" />
        <input type="hidden" name="cognome" [value]="this.infoForm.get('lastName')?.value" />
        <input type="hidden" name="mail" [value]="getValidMail(this.infoForm.get('email')?.value)" />
        <input type="hidden" name="itemsNumber" [value]="'1'" />
        <input type="hidden" name="Item_code_1" [value]="'WELLDONE'" />
        <input type="hidden" name="Item_quantity_1" [value]="'1'" />
        <input type="hidden" name="Item_amount_1" [value]="'10'" />
        <input type="hidden" name="Item_description_1" [value]="'WELL DONE'" />
        <input type="hidden" name="TCONTAB" [value]="'C'" />
        <input type="hidden" name="shipIndicator" [value]="'05'" />
        <input type="hidden" name="selectedcard" value="PAGODIL" />
    </form>
</ng-container>
